import { fieldValidationMessages } from 'app/constants';

export const formErrorMessages = {
  errors: {
    title: {
      maxLength: (props: [string, { maxLength: number }]) => {
        return fieldValidationMessages.MAX_CHAR(props[1].maxLength);
      },
    },
  },
};
